// cart.js (or inline in each file if you prefer)
export const CART_KEY = "cart";

export const readCart = () => {
  try { return JSON.parse(localStorage.getItem(CART_KEY) || "[]"); }
  catch { return []; }
};
export const writeCart = (items) => {
  localStorage.setItem(CART_KEY, JSON.stringify(items));
  const count = items.reduce((n, it) => n + (Number(it.qty) || 0), 0);
  window.dispatchEvent(new CustomEvent("cartUpdated", { detail: { items, count } }));
};
export const addToCart = (item) => {
  const items = readCart();
  const idx = items.findIndex(i => i.id === item.id);
  if (idx >= 0) items[idx].qty += item.qty;
  else items.push(item);
  writeCart(items);
};
